import { Button, ButtonLoader } from "../Button"
import { Input, TextArea } from "../Form"
import { ModalBody, ModalHeader, ModalPanel } from "../Modal"
import ModalHeaderBack from "../ModalHeaderBack"
import QRCodeComponent from "../QrCode"
import { QrCodeHistoryList } from "../QrCodeHistoryList"
import "./styles.scss"

export const QrCodeModal = ({
  project = {},
  modalIsOpen,
  handleCloseModal,
  handleCloseGenerateQrCode,
  handleOpenGenerateQrCode,
  isGenerateQrCode,
  register,
  handleSubmit,
  handleDeleteQrCode,
  watch,
  getMessageLink,
  loadingSave,
  loading,
  qrCodeData,
}) => {
  return (
    <ModalPanel modalIsOpen={modalIsOpen}>
      {isGenerateQrCode ? (
        <>
          <ModalHeader closeModal={handleCloseModal}>
            <ModalHeaderBack
              title="Gerador de QR code do Projeto"
              handleGoBack={handleCloseGenerateQrCode}
            />
          </ModalHeader>
        </>
      ) : (
        <ModalHeader title={`QR code do Projeto: ${project?.name}`} closeModal={handleCloseModal} />
      )}
      <ModalBody className="modal-container-qrcode">
        <div className="modal-container-qrcode__body">
          {isGenerateQrCode ? (
            <div className="qrcode-generate">
              <div className="qrcode-generate-image">
                <QRCodeComponent
                  content={getMessageLink(watch("receivedMessage"), project?.value)}
                />
              </div>
              <div className="qrcode-generate-input-fields">
                <div className="qrcode-generate-input-fields-block">
                  <span className="label-field">Dê um título para o QRCode <span className="label-field-required">*</span></span>
                  <Input
                    hasFocus={false}
                    register={register("title", {
                      required: { value: true, message: "Campo Obrigatório" },
                    })}
                    maxLength={140}
                  />
                </div>
                <div className="qrcode-generate-input-fields-block">
                  <span className="label-field">Mensagem que será recebida do beneficiário <span className="label-field-required">*</span></span>
                  <TextArea
                    register={register("receivedMessage", {
                      required: { value: true, message: "Campo Obrigatório" },
                    })}
                    maxLength={1000}
                  />
                  <p className="word-limit">
                    {watch("receivedMessage")?.length || 0}
                    <span>/{1000} caracteres</span>
                  </p>
                </div>
                <div className="qrcode-generate-input-fields-block">
                  <span className="label-field">Mensagem que será enviada para o beneficiário <span className="label-field-required">*</span></span>
                  <TextArea
                    register={register("feedbackMessage", {
                      required: { value: true, message: "Campo Obrigatório" },
                    })}
                    maxLength={1000}
                  />
                  <p className="word-limit">
                    {watch("feedbackMessage")?.length || 0}
                    <span>/{1000} caracteres</span>
                  </p>
                </div>
                <div className="qrcode-generate-button">
                  <ButtonLoader
                    label="Gerar QRCode"
                    isDisabled={!watch("receivedMessage") || !watch("title")}
                    handleClick={handleSubmit}
                    loading={loadingSave}
                  />
                </div>
              </div>
            </div>
          ) : (
            <>
              <header className="modal-container-qrcode__header">
                <span className="qrcode__header-title">QRCodes Gerados</span>
                <Button label="Gerar QRCode" handleClick={handleOpenGenerateQrCode} />
              </header>
              <QrCodeHistoryList
                loading={loading}
                data={qrCodeData.sort(
                  (a, b) => a?.createdAt?.nanoseconds > b?.createdAt?.nanoseconds,
                )}
                handleDeleteQrCode={handleDeleteQrCode}
              />
            </>
          )}
        </div>
      </ModalBody>
    </ModalPanel>
  )
}
